var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('register-command',{attrs:{"name":"generateData","config":_vm.generateDataCommandConfig,"extend":"copy"}}),_c('register-command',{attrs:{"name":"downloadImage","config":_vm.downloadImageCommandConfig,"extend":"copy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }